export const blockIconsMapsLocalParkingNew = (
	<span className='material-symbols-outlined'>local_parking</span>
);
